export default __webpack_public_path__ + "static/media/SG.b892324a.svg";